import { Pipe, PipeTransform } from '@angular/core';
import {Nalgene } from './nalgene';

@Pipe({
  name: 'BooleanPipe'
})
export class BooleanPipe implements PipeTransform {
//   transform(id: number) {

//     return 23;
    
        
//   }
    transform(val:boolean){
        let output:string = "No";
       if(val){
        output = "Yes"
       }
       return output;
        
    }
       
}


// WEBPACK FOOTER //
// /Users/thomas.obrien2/projects/nalgene/src/app/categories/boolean.pipe.ts